import Draggable from '../../utils/Draggable/Draggable';
import TextPreset from '../TextPreset';
import Renderer from '../../Renderer';

export default class DraggablePreset extends TextPreset {
  /**
   * @param app {PIXI.Application}
   */
  constructor(app) {
    super({ app, isFullScreen: false, requiresRootTransform: false });

    this.draggable = new Draggable({
      app,
      contents: this.container,
      anchor: this.root.anchor,
    });
    this.setupDraggable();

    this.parent.addChild(this.draggable.container);
  }

  get minFontSize() {
    return Renderer.getInstance().minFontSize;
  }

  _onDragMove() {
    this.container.scale.set(this._safeScale(this.container.scale.x));

    // Keep draggable in sync with changes due to scale
    this.updateDraggable();
    this.render();
  }

  _safeScale(scale) {
    const minScale = this.minFontSize / this.originalFontSize; // Text cannot be shrunk below minimum font size.
    return Math.max(minScale, scale);
  }

  _onClick(event) {
    Renderer.emit(Renderer.CLICK_ITEM, this.model, event);
  }

  _onDragEnd(wasMoved, wasScaled) {
    this.updateDraggable();
    this.container.cacheAsBitmap = false;

    const { horizontal, vertical } = this.getRelativePosition(this.root, {
      x: this.container.x,
      y: this.container.y,
    });
    const newRelativePosition = {
      x: horizontal,
      y: vertical,
    };

    if (wasMoved) {
      Renderer.emit(Renderer.MOVE_ITEM, this.model, newRelativePosition);
    }
    if (wasScaled) {
      Renderer.emit(
        Renderer.SCALE_ITEM,
        this.model,
        this.container.scale.x,
        newRelativePosition
      );
    }
  }

  setupDraggable() {
    if (!this.app.isInteractive) this.draggable.turnOffInteraction();

    this.draggable.onClick = this._onClick.bind(this);
    this.draggable.onDrag = this._onDragMove.bind(this);
    this.draggable.onEnd = this._onDragEnd.bind(this);
    this.draggable.safeScale = this._safeScale.bind(this);
  }

  update(model) {
    this.position = model.position ?? {};

    super.update(model);
  }

  updateDraggable() {
    this.draggable.update(this.container.getBounds());
  }

  setDraggableRoot(height = 0, width = 0) {
    this.setRoot({
      height,
      width,
      horizontal: this.position.x,
      vertical: this.position.y,
      anchorX: this.root.anchor?.x,
      anchorY: this.root.anchor?.y,
    });

    this.updateDraggable();
  }
}
